import type { DesignTokens } from '@tunasong/ui-lib'

export const getGuitarColors = (tokens: DesignTokens) => ({
  /** Constants */
  labelStyle: tokens.palette.text.primary,
  labelText: tokens.palette.background.default,
  muteStyle: tokens.palette.action.active,
  outlineStyle: tokens.palette.divider,
  watermarkStyle: tokens.palette.text.secondary,
  nutStyle: tokens.palette.action.disabled,
  fretStyle: tokens.palette.text.primary,
  inlayStyle: tokens.palette.action.disabled,
  stringStyle: tokens.palette.text.secondary,
  fingeringStyle: tokens.notes.main,
  fingeringStyleInScale: tokens.notes.inScale,
  fingeringStyleOutOfScale: tokens.notes.outOfScale,
  fingeringStyleRoot: tokens.notes.root,
})
